import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Box,
  Typography,
  TextField,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { jwtDecode } from "jwt-decode";

const getAccessToken = () => localStorage.getItem("accessToken") || null;

const decodeToken = () => {
  const token = getAccessToken();
  if (!token) return null;

  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

const userData = decodeToken();

const isBranch3 = userData?.branchId === 3;

console.log(45,isBranch3)

const companyOptions = [
  "บริษัท ณสุ จำกัด (Nasu)",
  "บริษัท สแควร์ไมล์กรุ๊ป จำกัด (SQM)",
];

const PaymentDialog = ({ open, onClose, onSelect }) => {
  const [companyName, setCompanyName] = useState(companyOptions[0]);

  const handleSelect = (method) => {
    onSelect({
      method,
      companyName: isBranch3 ? "-" : companyName,
    });

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>เลือกวิธีชำระเงิน</DialogTitle>
      <DialogContent>
        <Typography variant="h6" color="textSecondary" sx={{ mb: 2 }}>
          หลังจากเลือกช่องทางการชำระเงินแล้ว จะแสดงหน้าปริ้นใบเสร็จ
        </Typography>

        {!isBranch3 && (
          <TextField
            select
            fullWidth
            label="บริษัท / ผู้ชำระเงิน"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            sx={{ mb: 2 }}
          >
            {companyOptions.map((company) => (
              <MenuItem key={company} value={company}>
                {company}
              </MenuItem>
            ))}
          </TextField>
        )}

        <Box display="flex" flexDirection="row" gap={2} mt={1}>
          <Button
            fullWidth
            variant="contained"
            color="success"
            onClick={() => handleSelect("เงินสด")}
            startIcon={<LocalAtmIcon />}
            sx={{ height: 60 }}
          >
            เงินสด
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => handleSelect("โอนเงิน")}
            startIcon={<AccountBalanceIcon />}
            sx={{ height: 60 }}
          >
            โอนเงิน
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDialog;
